import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
  widget: {
    display: "flex", alignItems: "center", gap: 8, cursor: "pointer",
    padding: "5px 10px", borderRadius: 9,
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(255,255,255,0.1)",
    transition: "all 0.15s",
    "&:hover": { background: "rgba(255,255,255,0.12)" },
  },
  balance: { fontWeight: 700, fontSize: "0.78rem", color: "#fff", lineHeight: 1 },
  label: { fontSize: "0.6rem", color: "rgba(255,255,255,0.5)", marginTop: 1 },
  bar: { width: 40, height: 3, borderRadius: 2, background: "rgba(255,255,255,0.15)", overflow: "hidden" },
  barFill: { height: "100%", borderRadius: 2, transition: "width 0.5s ease" },
  dot: { width: 7, height: 7, borderRadius: "50%", flexShrink: 0 },
}));

const ALERT_COLORS = { critical: "#EF4444", danger: "#F97316", warning: "#EAB308" };

const AICreditsWidget = () => {
  const classes = useStyles();
  const history = useHistory();
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => api.get("/ai-credits/balance").then(r => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!data) return null;

  const pct = data.monthlyIncluded > 0 ? Math.round((data.balance / data.monthlyIncluded) * 100) : 100;
  const barColor = data.alertLevel ? ALERT_COLORS[data.alertLevel] : "#22C55E";

  return (
    <div className={classes.widget} onClick={() => history.push("/ai-credits")} title="Créditos IA Korax">
      <span style={{ fontSize: "0.9rem" }}>⚡</span>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span className={classes.balance}>{data.balance.toLocaleString()} créditos</span>
        <div className={classes.bar} style={{ marginTop: 3 }}>
          <div className={classes.barFill} style={{ width: `${Math.min(pct, 100)}%`, background: barColor }} />
        </div>
      </div>
      {data.alertLevel && (
        <div className={classes.dot} style={{ background: barColor, boxShadow: `0 0 6px ${barColor}` }} />
      )}
    </div>
  );
};

export default AICreditsWidget;
